import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ServiceFileValidationDataTypes } from "../../../Schema/serviceFileValidation.types";
import { useAppDispatch, useAppSelector } from "../../../Hooks/useStore";
import { useCallback } from "react";

export type ValidationDataInitialStateTypes = {
  data: ServiceFileValidationDataTypes[];
};

const initialState = {
  data: [],
} as ValidationDataInitialStateTypes;

export const validationDataSlice = createSlice({
  name: "validationDataSlice",
  reducers: {
    setValidationData: (
      state,
      action: PayloadAction<ServiceFileValidationDataTypes>,
    ) => {
      const isExist = state.data.find(
        (item) => item.question_id === action.payload.question_id,
      );
      if (isExist) {
        state.data = state.data.filter(
          (item) => item.question_id !== action.payload.question_id,
        );
      }
      state.data.push(action.payload);
    },
    removeValidationData: (state, action: PayloadAction<number>) => {
      state.data = state.data.filter(
        (item) => item.question_id !== action.payload,
      );
    },
    resetValidationData: (state) => {
      state.data = [];
    },
  },
  initialState,
});

export const { setValidationData, removeValidationData, resetValidationData } =
  validationDataSlice.actions || {};
export default validationDataSlice.reducer;

export const useValidationData = () => {
  const dispatch = useAppDispatch();
  const { data: validationData } = useAppSelector(
    (state) => state.validationData,
  );

  const dispatchRemoveValidationData = useCallback(
    (data: number) => {
      dispatch(removeValidationData(data));
    },
    [dispatch],
  );

  const dispatchResetValidationData = useCallback(() => {
    dispatch(resetValidationData());
  }, [dispatch]);

  return {
    validationData,
    dispatchRemoveValidationData,
    dispatchResetValidationData,
  };
};
